module.exports = __webpack_public_path__ + "static/img/no_data.07db3ea0.png";